"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// returns the complete state as-is
function all(state) {
    return state;
}
exports.all = all;
// IBE-ized persons configuration structure
function asAgeGroups(state) {
    return {
        A: state.adults,
        J: state.juveniles,
        C: state.children
    };
}
exports.asAgeGroups = asAgeGroups;
// state grouped into "full aged" persons (adults) and children
function asPersonGroups(state) {
    return {
        adults: state.adults + state.juveniles,
        children: state.children
    };
}
exports.asPersonGroups = asPersonGroups;
// humanized String representation of the state
function asString(state) {
    if (locked(state)) {
        return "2 Personen";
    }
    var result = [];
    if (state.adults > 0) {
        result.push(state.adults + " Erwachsene" + (state.adults > 1 ? '' : 'r'));
    }
    if (state.juveniles > 0) {
        result.push(state.juveniles + " Jugendliche" + (state.juveniles > 1 ? '' : 'r'));
    }
    if (state.children > 0) {
        result.push(state.children + " Kind" + (state.children > 1 ? 'er' : ''));
    }
    return result.join(', ');
}
exports.asString = asString;
// humanized short String representation of the state
function asShortString(state) {
    if (locked(state)) {
        return "2 Pers.";
    }
    var result = [];
    if (state.adults > 0) {
        result.push(state.adults + " Erw.");
    }
    if (state.juveniles > 0) {
        result.push(state.juveniles + " " + (state.juveniles > 1 ? 'Jugendl.' : 'Jugdl.'));
    }
    if (state.children > 0) {
        result.push(state.children + " Kind" + (state.children > 1 ? 'er' : ''));
    }
    return result.join(', ');
}
exports.asShortString = asShortString;
// can any person be removed from the state, minimum is 0
function canDec(state) {
    return function (type) {
        if (locked(state)) {
            return false;
        }
        switch (type) {
            case 'adults':
                return canDecrementAdults(state);
            case 'juveniles':
                return canDecrementJuveniles(state);
            case 'children':
                return canDecrementChildren(state);
        }
        return false;
    };
}
exports.canDec = canDec;
// can any person be added to the state, limit is 5
function canInc(state) {
    if (locked(state)) {
        return false;
    }
    return total(state) < 5;
}
exports.canInc = canInc;
// can any person be removed from the state, minimum is 0
function canDecrementAdults(state) {
    if (locked(state)) {
        return false;
    }
    return state.adults > 0;
}
exports.canDecrementAdults = canDecrementAdults;
// can any person be added to the state, limit is 5
function canIncrementAdults(state) {
    if (locked(state)) {
        return false;
    }
    return canInc(state);
}
exports.canIncrementAdults = canIncrementAdults;
// can any person be removed from the state, minimum is 0
function canDecrementJuveniles(state) {
    if (locked(state)) {
        return false;
    }
    return state.juveniles > 0;
}
exports.canDecrementJuveniles = canDecrementJuveniles;
// can any person be added to the state, limit is 5
function canIncrementJuveniles(state) {
    if (locked(state)) {
        return false;
    }
    return canInc(state);
}
exports.canIncrementJuveniles = canIncrementJuveniles;
// can any person be removed from the state, minimum is 0
function canDecrementChildren(state) {
    if (locked(state)) {
        return false;
    }
    return state.children > 0;
}
exports.canDecrementChildren = canDecrementChildren;
// can any person be added to the state, limit is 5
function canIncrementChildren(state) {
    if (locked(state)) {
        return false;
    }
    return canInc(state);
}
exports.canIncrementChildren = canIncrementChildren;
// sum of all persons that are considered full-aged (~ above 18)
function fullAged(state) {
    return state.adults + state.juveniles;
}
exports.fullAged = fullAged;
// is the current state a valid combination
function isValid(state) {
    return fullAged(state) > 0 &&
        total(state) <= 5 &&
        state.adults >= 0 &&
        state.juveniles >= 0 &&
        state.children >= 0 &&
        state.adults <= 5 &&
        state.juveniles <= 5 &&
        state.children <= 4;
}
exports.isValid = isValid;
// sum of all persons
function total(state) {
    return state.adults + state.juveniles + state.children;
}
exports.total = total;
function locked(state) {
    return state.locked;
}
exports.locked = locked;
// export everything compliant to the vuex specification for getters
exports.default = {
    all: all, asAgeGroups: asAgeGroups, asPersonGroups: asPersonGroups, asString: asString, asShortString: asShortString, canDec: canDec, canInc: canInc,
    fullAged: fullAged, isValid: isValid, total: total, locked: locked, canDecrementAdults: canDecrementAdults, canIncrementAdults: canIncrementAdults,
    canDecrementJuveniles: canDecrementJuveniles, canIncrementJuveniles: canIncrementJuveniles, canDecrementChildren: canDecrementChildren,
    canIncrementChildren: canIncrementChildren
};
//# sourceMappingURL=getters.js.map